import React, { useEffect, useState } from 'react';
import Card from '../../components/cards/Card';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import Table from '../../components/tables/Table';
import Pagination from '../../components/tables/pagination/Pagination';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Breadcrumbs from '../../components/BreadCrumbs';
import { getProductVisitors } from '../../services/product_visitors';
import { toast } from 'react-toastify';
import { BiNotepad, BiRefresh } from 'react-icons/bi';
import ShowModal from '../../utils/ShowModal';
import AddProductVisitorNote from './AddProductVisitorNote';
import Dropdown from '../../components/inputFields/DropDown';
import DatePicker from '../../components/inputFields/DatePicker';
import SearchBar from '../../components/searchBar/SearchBar';
import { statesOfIndia } from '../../constants/states';
import { getUserRole } from '../../helpers/local_storage_helpers';
import ViewProductView from './ViewProductsView';
import { RiProductHuntFill } from 'react-icons/ri';
import DateRangePicker from '../../components/inputFields/DateRangePicker';


function ProductVisitorView() {
    const [modalIsOpen, setIsOpen] = useState(false);
    const [modalIsOpenProducts, setIsOpenProducts] = useState(false);
    const [openingItem, setOpeningItem] = useState({});

    const [cardData, setCardData] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [filteredState, setFilteredState] = useState("");
    const [filterDate, setFilterDate] = useState({ start: null, end: null });

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const headers = [
        { label: "Attended", key: "attended" },
        getUserRole() === "admin" ? { label: "Att. By", key: "attended_by" } : {},
        { label: "Type", key: "user_type" },
        { label: "Visit Time", key: "created_at" },
        { label: "Name", key: "name" },
        { label: "Product", key: "product_name" },
        { label: "Phone", key: "phone_number" },
        { label: "State", key: "state" },
        { label: "Platform", key: "platform" },
        { label: "Note", key: "note" },
    ];

    const pageSize = 20;

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchData = async (query) => {
        setLoading(true);
        try {
            let res = await getProductVisitors(query);
            if (res.status === 200) {
                const data = res.data;
                setData(data)
                setCardData(data.results.analytics);
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(`date=${filterDate}`);
    }, []);

    // Open modal with the selected PDF ID
    const openModal = (item) => {
        setOpeningItem(item);
        setIsOpen(true);
    };

    // Close modal
    const closeModal = () => {
        setIsOpen(false);
        setOpeningItem({});
    };

    // Open modal with the selected PDF ID
    const openProductModal = (item) => {
        setOpeningItem(item);
        setIsOpenProducts(true);
    };

    // Close modal
    const closeProductModal = () => {
        setIsOpenProducts(false);
        setOpeningItem({});
    };

    const onSave = () => {
        fetchData(`user=${searchText}&start_date=${filterDate.start || ""}&end_date=${filterDate.end || ""}&state=${filteredState}&page=${currentPage}`);
        closeModal();
    };

    const handleSearch = (query) => {
        setSearchText(query);
        fetchData(`user=${query}&start_date=${filterDate.start || ""}&end_date=${filterDate.end || ""}&state=${filteredState}`);
    };

    const handleDateChange = (value) => {
        setFilterDate(value);
        fetchData(`user=${searchText}&start_date=${value.start || ""}&end_date=${value.end || ""}&state=${filteredState}`);
    };

    const handleStateChange = (value) => {
        setFilteredState(value);
        fetchData(`user=${searchText}&start_date=${filterDate.start || ""}&end_date=${filterDate.end || ""}&state=${value}`);
    };

    const resetFilters = () => {
        setSearchText("");
        setFilterDate({ start: null, end: null });
        setFilteredState("");
        fetchData("");
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Enquiries' },
            { name: 'Product Visitors' },
        ]} />
        <div className="py-3">
            <StyledHeadingText text={"Visitors"} />
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">
                {cardData.map((card, index) => (
                    <Card title={card.title} count={card.value} />
                ))}
            </div>
        </div>
        <div className="flex flex-row gap-2 items-center">
            <SearchBar
                placeholder="Search for Number/ Name"
                onSearch={handleSearch}
                value={searchText}
            />

            <div className="min-w-48">
                <Dropdown
                    placeholder="Select State"
                    options={statesOfIndia.map((e) => ({ label: e, value: e }))}
                    onChange={handleStateChange}
                    value={filteredState}
                />
            </div>

            {/* Date Picker */}
            <div className="min-w-48">

                <DateRangePicker
                    value={filterDate}
                    onChange={handleDateChange}
                    placeholder="Date"
                />
            </div>
            {/* Reset Filters Icon */}
            {(searchText.length !== 0 || filterDate.start !== null || filterDate.end !== null || filteredState.length !== 0) && (
                <BiRefresh
                    size={30}
                    className="cursor-pointer text-primary"
                    onClick={resetFilters}
                />
            )}
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={data?.results?.records?.map((item, index) => (
                            {
                                attended: <div className={`w-4 aspect-square rounded-full ${item.note && item.note.length !== 0 ? "bg-primary" : "bg-red-700"}`}></div>,
                                attended_by: <p className='max-w-24 truncate'>{item.staff_name}</p>,
                                name: <p>{item.name}</p>,
                                user_type: <p className={`text-xs ${item.user_type == "new" ? "bg-primary" : item.user_type == "old" ? "bg-green-500" : "bg-red-500"} text-white font-bold text-center rounded-full p-1`}>{item.user_type.toUpperCase()}</p>,
                                created_at: <p>{item.date} {item.time}</p>,
                                product_name: <RiProductHuntFill size={24} color='green' onClick={() => openProductModal(item)} className='cursor-pointer' />,
                                phone_number: <p>{item.phone_number}</p>,
                                state: <p>{item.state}</p>,
                                platform: <p>{item.platform}</p>,
                                note: <BiNotepad size={24} color='green' onClick={() => openModal(item)} className='cursor-pointer' />,
                            }))}
                    />
                </div>}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            data.count !== 0 ?
                <Pagination
                    currentPage={currentPage}

                    pageSize={pageSize}
                    totalEntries={data?.count}
                    onPageChange={handlePageChange}
                    data={data}
                    setData={setData}
                /> : <></>
        }
        <ShowModal contentLabel={"Note alert"} isOpen={modalIsOpen} modalWidth="50%" isSidebar={true} onRequestClose={closeModal} componentToPass={<AddProductVisitorNote item={openingItem} onSave={onSave} />} />
        <ShowModal contentLabel={"Products alert"} isOpen={modalIsOpenProducts} modalWidth="50%" isSidebar={true} onRequestClose={closeProductModal} componentToPass={<ViewProductView item={openingItem} />} />
    </>);
}

export default ProductVisitorView;